import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { environment } from 'src/environments/environment';
import * as LoadMessageActions from '../../../messagingV3/legacy/actions/load-message.actions';
import * as fromRoot from '../../../reducers';
import * as fromSettings from '../../../settings/reducers';
import * as DashboardActions from '../../actions/dashboard.actions';
import { TableMedicationAction } from '../../models/MedicationAction';
import * as fromDashboard from '../../reducers';

@Component({
  selector: 'portal-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {
  public nonTimedTriggerMedication$: Observable<TableMedicationAction[]>;
  public medication$: Observable<TableMedicationAction[]>;
  public tableText$: Observable<any>;

  public nonTimedTriggerTableText$: Observable<any>;
  public nonTimedTriggerTableText: any;

  public tableText: any;
  public sectionText: any;

  // timer for refreshing dashboard
  private interval;

  private _subs = new Subscription();
  public displayedColumnList: string[] = ['name', 'type', 'drug', 'dueDate'];

  constructor(
    private _store: Store<fromRoot.State>,
    private _navigationService: NavigationService
  ) {
    // Setup Observables
    this.tableText$ = this._store.pipe(
      select(fromSettings.getSectionTranslations('UpcomingDrugs'))
    );
    this.nonTimedTriggerTableText$ = this._store.pipe(
      select(fromSettings.getSectionTranslations('NonTimedTriggerDrugs'))
    );
    this.medication$ = this._store.pipe(
      select(fromDashboard.getDashboardMedications),
      map((meds) => {
        return meds.Medication.filter((med) => med.StatusId === 2).map(
          (med) => ({
            id: med.PatientId,
            name: `${med.FirstName} ${med.LastName} (${med.PatientIdentifier})`.toUpperCase(),
            type: med.Type,
            drug: med.DrugName,
            dosage: med.DrugDosage,
            status: med.Status,
            statusId: med.StatusId,
            dueDate: med.DueDate
          })
        );
      })
    );

    this.nonTimedTriggerMedication$ = this._store.pipe(
      select(fromDashboard.getDashboardNonTimedTriggerMedications),
      map((meds) => {
        return meds.Medication.filter((med) => true).map((med) => ({
          id: med.PatientId,
          name: `${med.FirstName} ${med.LastName} (${med.PatientIdentifier})`.toUpperCase(),
          type: med.Type,
          drug: med.DrugName,
          dosage: med.DrugDosage,
          status: med.Status,
          statusId: med.StatusId,
          dueDate: med.DueDate
        }));
      })
    );

    // capture text entries to feed into components
    this._subs.add(this.tableText$.subscribe((val) => (this.tableText = val)));
    this._subs.add(
      this.nonTimedTriggerTableText$.subscribe(
        (val) => (this.nonTimedTriggerTableText = val)
      )
    );
  }

  ngOnInit() {
    // reload dashboard straight away and then
    // every 30 seconds
    this.load();
    this.interval = setInterval(() => {
      this.load();
    }, 1000 * environment.dashboardRefreshIntervalSeconds);
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
    this._subs.unsubscribe();
  }

  public gotoPatient(number: string): void {
    this._navigationService.navigate([`/patients/${number}`]);
  }

  public load(): void {
    this._store.dispatch(new DashboardActions.RefreshClinicDashboard());
    this._store.dispatch(new LoadMessageActions.LoadMessagingSummary());
  }
}
